import core from "@gtmhub/core/module";
import { WorkflowCtrl } from "./controllers/workflow";

export default angular.module("workflow", [core]).controller("WorkflowCtrl", WorkflowCtrl).name;
